<script>
	// export let currTimeDisplay;
	// export let totalTimeDisplay;
	export let progress;
</script>

<!-- <div id="time">
	<span id="progress-time">{currTimeDisplay}</span>
	<span id="track-duration">{totalTimeDisplay}</span>
</div> -->

<div class="progress-bar-cont">
	<span class="bar" style="width: {progress}%" />
</div>

<style>
	.progress-bar-cont {
		width: 100%;
		height: 3px;
		margin: 0.5rem 0 0.5rem;
		display: flex;
		align-items: center;
		cursor: pointer;
		background: #2d2b32;
		border-radius: 1.5px;
	}

	.bar {
		width: 0%;
		height: 100%;
		background-color: #d9d9d9;
		border-radius: 1.5px;
	}
</style>
